interface IIntersectObserver {
  element: HTMLElement | HTMLElement[] | NodeListOf<HTMLElement>
  callback: ((target: HTMLElement) => void)[] // 2nd function for none-intersect and clearAfterIntersect = false
  clearAfterIntersect?: boolean
  option?: object
}
export const intersectObserver = ({
  element,
  callback,
  clearAfterIntersect = true,
  option = { threshold: 0.3 },
}: IIntersectObserver) => {
  // const arg = { ...defaultSetting, ..._arg }

  const elements = element instanceof HTMLElement ? [element] : (Array.from(element) as HTMLElement[])

  // Set observer
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      const target = entry.target as HTMLElement

      if (entry.isIntersecting) {
        // After intersect, call first callback
        if (callback[0]) callback[0](target)

        if (clearAfterIntersect) {
          observer.unobserve(target)
        }
      } else {
        // After none-Intersect, call 2ndcallback
        if (callback[1]) callback[1](target)
      }
    })
  }, option)
  elements.forEach((el) => observer.observe(el))
  return observer
}
